module.exports = __webpack_public_path__ + "media/coffee-preferences/roast_unsure-dec1267c.png";